/* eslint-disable */
import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

// Types
import { TCustomGFIDKPProps } from '@/@types/views/map';
import { DCRecord } from '@/@types/lib/dataController';

// Custom
import MapCardActionButton from '@/ui/MapCard/MapCardActionButton';
import DataController from '@/lib/DataController';
import modelVlasnici from '@/models/vlasnici';
import ModelTable from '@/ui/Table/ModelTable';

// MUI
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { OpenInNew } from '@mui/icons-material';

const VlasniciButton = (props: TCustomGFIDKPProps) => {
  const identifier = "vlasnici";

  const [recordsVlasnici, setRecordsVlasnici] = useState<DCRecord[]>([]);

  const dcVlasnici = new DataController(modelVlasnici);

  const { t } = useTranslation();

  const { featureData, record, onToggle, addToCache, getFromCache } = props;

  const { layerData } = featureData;
  const { layer } = layerData;

  const recordId = useMemo(() => {
    return record ? (record.id ? record.id : record.fid ? record.fid : null) : null;
  }, [record]);

  const layerTag = useMemo(() => {
    const layerNameParts = layer.split("_", 2);
    return layerNameParts.length === 2 ? layerNameParts[1].toLowerCase() : layerNameParts[0].toLowerCase();
  }, [layer]);

  const loadVlasniciDKP = useCallback(() => {
    if (record) {
      const cachedRecords = getFromCache(identifier, record.id as number)
      if (cachedRecords) {
        setRecordsVlasnici(cachedRecords as DCRecord[]);
      } else {
        dcVlasnici.GetData(`data/dkp/${record.id}/zk-vlasnici/`).then((resp) => {
          if (resp.success && Array.isArray(resp.data)) {
            setRecordsVlasnici(resp.data);
            addToCache(identifier, record.id as number, resp.data);
          }
        });
      }
    }
  }, [record]);

  useEffect(() => {
    if (record && record.id) {
      setRecordsVlasnici([]);
      loadVlasniciDKP();
    }
  }, [recordId, layerTag, loadVlasniciDKP]);

  const memoizedModelTable = useMemo(() => (
    <ModelTable
      allowExport
      allowFilter
      title="" 
      size='small'
      tableName="vlasnici"
      viewName="default"
      records={recordsVlasnici || []}
      dc={dcVlasnici}
      allowSelection="none"
      allowAdd={false}
      allowRowAction={() => false}
      onRowAction={() => { }}
      disableControls={false}
      allowColumnPicker
    />
  ), [recordsVlasnici]);

  const handleToggleVlasnici = () => {
    onToggle(memoizedModelTable, identifier);
  };

  return (
    <MapCardActionButton
      startIcon={<AssignmentIndIcon />}
      onClick={handleToggleVlasnici}
      disabled={recordsVlasnici.length === 0}
      endIcon={<OpenInNew/>}
    >
      {t('dkp.vlasnici')}
    </MapCardActionButton>
  );
};

export default VlasniciButton;
